import script from "./CRMEditForm.vue?vue&type=script&setup=true&lang=js"
export * from "./CRMEditForm.vue?vue&type=script&setup=true&lang=js"

import "./CRMEditForm.vue?vue&type=style&index=0&id=05f19df6&scoped=true&lang=css"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05f19df6"]])

export default __exports__